import ApiProjects from "../../api/projects";
import { setProjectList } from "../slices/projects";

export const refreshProjects = () => async (dispatch) => {
  const res = await ApiProjects.getMine();
  const list = res.data && res.data.projects ? res.data.projects : [];
  dispatch(setProjectList(list));
};

